import React from "react";
import PropTypes from "prop-types";
// Styles
import styles from "./TableTitleBar.css";

const TableTitleBar = ({ disablePreviousNav, navigateDates, assignmentDate }) => (
  <table
    width="100%"
    className="table table-striped table-bordered dataTable no-footer table-no-margin"
  >
    <thead>
      <tr role="row">
        <th style={styles.leftNavigateButton}>
          <button
            type="button"
            disabled={disablePreviousNav}
            style={styles.buttonTransparent}
            onClick={() =>
              navigateDates({
                prev: true
              })
            }
          >
            <i
              className="fa fa-chevron-left"
              style={disablePreviousNav ? styles.disabledIcon : null}
            />
          </button>
        </th>
        <th colSpan={4 * 8 + 4} width="100%" style={styles.dateHeader}>
          {assignmentDate}
        </th>
        <th style={{ float: `right` }}>
          <button
            type="button"
            style={styles.buttonTransparent}
            onClick={() =>
              navigateDates({
                next: true
              })
            }
          >
            <i className="fa fa-chevron-right" />
          </button>
        </th>
      </tr>
    </thead>
  </table>
);

TableTitleBar.propTypes = {
  disablePreviousNav: PropTypes.bool.isRequired,
  navigateDates: PropTypes.func.isRequired,
  assignmentDate: PropTypes.string
};

export default TableTitleBar;
